export const PHONE_NUMBER = "9145569693"
export const EMERGENCY_CONTACT_NUMBER = "+91 +91-9145569693"

// Section Id's
export const HOME_SECTION_ID = "banner-section"
export const SERVICE_SECTION_ID = "service-section"
export const TESTIMONIAL_SECTION_ID = "testimonial-section"
export const BLOGS_SECTION_ID = "blogs-section"
export const CONTACTUS_SECTION_ID = "contact-section"
export const ABOUTUS_SECTION_ID = "about-us"